
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","viewBox":"0 0 16 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.2286 0.622643C11.5254 3.25433 12.9504 4.82332 15.4279 4.99024V7.95019C13.9921 8.09485 12.7345 7.6108 11.2717 6.69833V12.2343C11.2717 19.267 3.83384 21.4647 0.843561 16.4239C-1.07799 13.1802 0.0986907 7.48839 6.26276 7.26028V10.3816C5.79317 10.4595 5.29119 10.5819 4.83239 10.7432C3.4614 11.2217 2.68414 12.1175 2.90005 13.6976C3.31567 16.7243 8.70248 17.6201 8.25448 11.7058V0.628206H11.2286V0.622643Z","fill":"currentColor"}})])
          )
        }
      }
    